import React, { Component } from 'react'
import _ from 'lodash'

import { updateModuleData } from 'helpers/specHelpers'
import ListSpec from 'containers/Project/ListSpec/index'

class MissionProfileSpec extends Component {

  genPowerOnOffString = (powerObj) =>
    powerObj.map(({tA, tJ, tPercent, tH}) => {
        [tA, tJ, tPercent, tH] = [tA, tJ, tPercent, tH].map(x => _.isNil(x) ? "" : x)
        return `Ta(C): ${tA}, Tj(C): ${tJ}, t(%): ${tPercent}, t(h): ${tH.toLocaleString()}`
      })

  combineData = (dataArr) => {
    const returnObj = {}

    dataArr.forEach((data, idx) => {
      const {
        vehicleType,
        serviceLife,
        powerOnHours,
        powerOffHours,
        mileage,
        powerOnOffCycles,
        powerOn,
        powerOff,
      } = data

      const [powerOnData, powerOffData] = 
        [powerOn, powerOff].map((powerObj) => 
          powerObj ? this.genPowerOnOffString(powerObj) : null)

      returnObj[idx] = {
        vehicleType,
        serviceLife,
        powerOnHours,
        powerOffHours,
        mileage,
        powerOnOffCycles,
        powerOn: powerOnData,
        powerOff: powerOffData
      }
    })

    return Object.values(returnObj)
  }

  render() {
    const {
      specModuleData,
      isModifiedPage,
      curFilter,
      ModuleHeader,
    } = this.props

    if(!specModuleData) return null

    const newModuleData = updateModuleData(_.cloneDeep(specModuleData), this.combineData)

    const config = {
      customModuleNames: {
        powerOn: "powerOn",
        powerOff: "powerOff"
      }
    }

    return (
      <ListSpec
        moduleName={ 'mission_profile' }
        moduleData={ newModuleData }
        isModifiedPage={ isModifiedPage }
        curFilter={curFilter}
        ModuleHeader={ModuleHeader}
        config={config}
      />
    )
  }
}

export default MissionProfileSpec
